export default "__VITE_ASSET__CnXi8NJ5__"